import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AppService, CartService, Host, MenuGroup, Table} from "../../../../common";

@Component({
  selector: 'service-call',
  standalone: false,
  template: `
    <div class="container fixed-bottom app-footer pt-2 pb-2">
      <button class="btn btn-block btn-warning" (click)="onClick()" i18n><i class="fa fa-bell"></i> Service Call</button>
    </div>
  `
})

export class ServiceCallButton implements OnInit, OnDestroy {

  constructor(
    private appService: AppService
  ) {}

  ngOnInit() {
    // TODO: this changes the screen size AFTER layout, bah!
    document.querySelector('body').classList.add('has-fixed-bottom')
  }

  ngOnDestroy() {
    document.querySelector('body').classList.remove('has-fixed-bottom')
  }

  onClick() {
    this.appService.sendServiceCall();
  }
}
